import React, { useRef } from 'react';
import styles from '../SendMessageStep.module.css';

interface EmailPreviewProps {
  html: string;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ html }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleLoad = () => {
    const iframe = iframeRef.current;
    const body = iframe?.contentWindow?.document.body;
    if (iframe && body) {
      iframe.style.height = `${body.scrollHeight}px`;
    }
  };

  return (
    <figure className={styles.emailPreviewFigure}>
      <iframe
        ref={iframeRef}
        srcDoc={html}
        title="Email Preview"
        sandbox="allow-same-origin"
        onLoad={handleLoad}
      />
    </figure>
  );
};
